// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"24":"non-react-concierge-ai-embed","209":"payment-confirmation","236":"reserve-online"}[chunkId] || chunkId) + "." + {"24":"5565a82f","152":"822afdff","209":"b3e957c5","236":"50fa0da4","818":"86ed5203"}[chunkId] + ".chunk.js";
};